import React from "react"
import PropTypes from "prop-types"
import "./extras-list.scss"
import Extra from "./extra"
import * as _ from "lodash"
import { useSelector, useDispatch } from "react-redux"
import { planHasHalo3 } from "redux/selectors/basket-selectors"
import { useEFSData } from "hooks/efs-input"
import { nextPage } from "redux/actions/journey-actions"

// Component to display the list of extras given via its props
const ExtrasList = ({
  onAddExtra,
  onRemoveExtra,
  selectedExtras,
  excludeVAT,
  extras = {}
}) => {
  const handleAddExtra = selectedID => onAddExtra(selectedID)
  const handleRemoveExtra = selectedID => onRemoveExtra(selectedID)

  const hasIntegratedHalo3 = useSelector(planHasHalo3)
  const { haveHalo } = useEFSData()

  // MAJOR HACK!!!! This is awful. Never do. Not even once
  // This never happen.
  if (hasIntegratedHalo3 && haveHalo === 1) {
    extras = Object.entries(extras).reduce((outputObj, [key, value]) => {
      if (key !== "COMPLETE_WIFI" && key !== "HYBRID_HUB") {
        return { ...outputObj, [key]: value }
      }

      return outputObj
    }, {})
  }

  // If no extras, go to the next page
  const dispatch = useDispatch()
  if (_.isEmpty(extras)) {
    dispatch(nextPage())
  }

  return (
    <div className="extras-list">
      {!_.isEmpty(extras) && <h4>Choose your extras</h4>}
      {Object.keys(extras).map(extraID => (
        <Extra
          text={extras[extraID].text}
          shortText={extras[extraID].shortText}
          cost={extras[extraID].cost}
          hoverText={extras[extraID].hoverText}
          onAddExtra={selectedID => handleAddExtra(selectedID)}
          onRemoveExtra={selectedID => handleRemoveExtra(selectedID)}
          id={extraID}
          selectedExtraIDs={selectedExtras}
          key={`extra_${extraID}`}
          excludeVAT={excludeVAT}
        />
      ))}
    </div>
  )
}

ExtrasList.propTypes = {
  extras: PropTypes.object.isRequired,
  onAddExtra: PropTypes.func.isRequired,
  onRemoveExtra: PropTypes.func.isRequired,
  selectedExtraIDs: PropTypes.arrayOf(PropTypes.string),
  excludeVAT: PropTypes.bool
}

ExtrasList.defaultProps = {
  selectedExtraIDs: [],
  excludeVAT: false
}

export default ExtrasList
